import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { requestQueries } from "@surgia/api/src/queryStore/admin/request";
import { formatDateWithMoment } from "@surgia/utils";
import { getContactName } from "@surgia/utils";
interface UseTenantRequestsParams {
  currentPage: number;
  search: string;
  filters: {
    id?: string;
    city?: string;
    type?: string;
    created_at_from?: string;
    created_at_to?: string;
  };
  size?: number;
  sort?: string;
  enabled?: boolean;
}

export const useGetTenantRequests = ({
  currentPage,
  search,
  filters,
  size = 8,
  sort,
  enabled = true,
}: UseTenantRequestsParams) => {
  return useQuery({
    ...requestQueries.queries.list({
      page: currentPage,
      size,
      status: "PENDING",
      name: search,
      id: filters.id ? filters.id.toString() : undefined,
      city_id: filters.city,
      type: filters.type,
      created_at_from: filters.created_at_from,
      created_at_to: filters.created_at_to,
      sort: sort,
      component_id: Number(import.meta.env.VITE_HUB_COMPONENT_ID),
    }),
    placeholderData: keepPreviousData,
    select: (data) => ({
      ...data,
      data: data.data.map((request) => ({
        id: request.id?.toString(),
        tenantName: request.name,
        type: request.type,
        city: request.city?.name || "Unknown",
        numberOfBranches: request.branches?.length || 0,
        status:
          (request.status?.toLowerCase() as
            | "active"
            | "pending"
            | "inactive") || "pending",
        contactName: getContactName(request),
        contactDetails: {
          email: request.contact_person_email || "",
          phone: request.contact_person_mobile || "",
        },
        dateCreated: formatDateWithMoment(request?.created_at),
      })),
    }),
    enabled,
  });
};
